import { render, staticRenderFns } from "./IncreaseRequestTable.vue?vue&type=template&id=057490ca&scoped=true&"
import script from "./IncreaseRequestTable.vue?vue&type=script&lang=js&"
export * from "./IncreaseRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./IncreaseRequestTable.vue?vue&type=style&index=0&id=057490ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057490ca",
  null
  
)

export default component.exports